import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {Link, NavLink, Route, Switch, withRouter} from "react-router-dom";
import GameComponent from "game/app/components/game/game-component";
import {sendInput} from "game/app/actions/game-instance-actions";
import {getLeaderboard} from "game/app/actions/leaderboard-actions";
import assets from "game/app/assets";
import Loading from "../../../layout/loading";
import {handleApiResponse} from "../../../../../../common/crud-actions";

class Leaderboard extends GameComponent {

    constructor(params) {
        super(params);
        this.state = {
            leaderboard: null
        }
    }

    componentWillMount() {
        let promise = this.props.getLeaderboard(this.getInstanceId());
        handleApiResponse('LEADERBOARD', 'LIST', promise,
            (response) => {
            this.setState({leaderboard: response.payload});
        }, (error) => {
            console.log(error);
        }, (error) => {
            console.log(error);
        });
    }

    render() {
        let previousChechtaky = 0;
        let previousIndex = 0;
        let order = 0;

        const { loading } = this.props.leaderboard;
        const data = this.state.leaderboard;
        const hasChechtaky = this.getInstanceProperty('STATS_CHECHTAKY') && this.getInstanceProperty('STATS_CHECHTAKY') > 0;

        if (!data || loading)
            return (<Loading/>);

        return (
            <div className='container'>
                <div className='row'>
                    <div className={this.mainContainerClass}>
                        <h1 className='page-title-minor separate-bottom'>Celkové hodnocení</h1>
                        <div className='card'>
                            <div className='card-body'>
                                <div className='row'>
                                    <div className='col-lg-4'>
                                        <p><img src={assets.resources.chechtaky}/></p>
                                        <p className='label'>Chechtáky</p>
                                    </div>
                                    <div className='col-lg-8'>
                                        <div className='row'>
                                            <div className='col-md-6'><strong>Celkem</strong></div>
                                            <div className='col-md-6 text-right'><strong>{ this.getInstanceProperty('STATS_CHECHTAKY') || 0 }</strong></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <h2>Celkové pořadí</h2>
                        {
                            hasChechtaky &&
                            <div className="table-responsive">
                                <table className='table bg-white result-table'>
                                    <thead>
                                    <tr><th className='text-left' colSpan='4'>Váš tým</th></tr>
                                    </thead>
                                    <tbody>
                                    <tr className='text-right'>
                                        <td className='one-fourth text-left'><span>{ data.total.position }.</span>{ data.total.equal > 0 && <span> - { data.total.position + data.total.equal }.</span> }</td>
                                        <td className='one-fourth'>{ this.getInstanceProperty('school') }</td>
                                        <td className='one-fourth'>{ this.getInstanceProperty('class') }</td>
                                        <td className='one-fourth'>{ this.getInstanceProperty('STATS_CHECHTAKY') }</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        }
                        <div className="table-responsive">
                            <table className='table bg-white result-table'>
                                <thead>
                                <tr><th className='text-left'>Pořadí</th><th className='text-right'>Název školy</th><th className='text-right'>Název týmu</th><th className='text-right'>Chechtáky</th></tr>
                                </thead>
                                <tbody>
                                { data.total.list && data.total.list.map((item, index) => {
                                    let currentChechtaky = item['chechtaky'];
                                    let currentIndex = index+1;

                                    if (currentChechtaky !== previousChechtaky) {
                                        order = currentIndex;
                                        previousChechtaky = currentChechtaky;
                                    }

                                    return (
                                        <tr key={index} className='text-right'>
                                            <td className='text-left one-fourth'>{order}.</td>
                                            <td className='one-fourth'>{ item.school }</td>
                                            <td className='one-fourth'>{ item.team }</td>
                                            <td className='one-fourth'>{currentChechtaky}</td>
                                        </tr>
                                    );
                                })}
                                </tbody>
                            </table>
                        </div>

                        <h2 className='separate-top'>Kraj: { this.getInstance().getRegionTitle() }</h2>

                        {
                            hasChechtaky &&
                            <div className="table-responsive">
                                <table className='table bg-white result-table'>
                                    <thead>
                                    <tr><th className='text-left' colSpan='4'>Váš tým</th></tr>
                                    </thead>
                                    <tbody>
                                    <tr className='text-right'>
                                        <td className='text-left one-fourth'><span>{ data.region.position }.</span>{ data.region.equal > 0 && <span> - { data.region.position + data.region.equal }.</span> }</td>
                                        <td className='one-fourth'>{ this.getInstanceProperty('school') }</td>
                                        <td className='one-fourth'>{ this.getInstanceProperty('class') }</td>
                                        <td className='one-fourth'>{ this.getInstanceProperty('STATS_CHECHTAKY') }</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>

                        }

                        <div className="table-responsive">
                            <table className='table bg-white result-table'>
                                <thead>
                                <tr className='text-right'>
                                    <th className='text-left one-fourth'>Pořadí</th>
                                    <th className='one-fourth'>Název školy</th>
                                    <th className='one-fourth'>Název týmu</th>
                                    <th className='one-fourth'>Chechtáky</th>
                                </tr>
                                </thead>
                                <tbody>
                                { data.region.list && data.region.list.map((item, index) => {
                                    let currentChechtaky = item['chechtaky'];
                                    let currentIndex = index+1;

                                    if (currentChechtaky !== previousChechtaky) {
                                        order = currentIndex;
                                        previousChechtaky = currentChechtaky;
                                    }

                                    return (
                                        <tr key={index}>
                                            <td className='text-left'>{order}.</td>
                                            <td className='text-right'>{ item.school }</td>
                                            <td className='text-right'>{ item.team }</td>
                                            <td className='text-right'>{currentChechtaky}</td>
                                        </tr>
                                    );
                                })}
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state,ownProps) {
    return {
        gameInstance: state.gameInstance,
        leaderboard: state.leaderboard
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        sendInput: sendInput,
        getLeaderboard: getLeaderboard
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, matchDispatchToProps)(Leaderboard));
